import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhua';

export default function CategoryPreview() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              探索漫画
              <br />
              分类世界
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            从恋爱到奇幻，从动作到悬疑，八大分类满足你所有的阅读偏好
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {displayCategories.slice(0, 4).map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`bg-background-50 rounded-xl p-5 cursor-pointer hover:scale-[1.02] transition-all duration-300 group ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{cat.description}</p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium">
                浏览分类 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {displayCategories.slice(4).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-xl p-5 cursor-pointer hover:scale-[1.02] transition-all duration-300 group"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{cat.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}